import React from 'react'
import PropTypes from 'prop-types'

const justifyMap = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
}

const DarkTabs = ({ tabs = [], activeTab, onTabChange, justify = 'center' }) => {
  return (
    <div className={`flex items-center ${justifyMap[justify] || 'justify-center'}`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`px-4 py-2 transition-all duration-200 ${
            activeTab === tab.id
              ? 'font-semibold text-dark border-b border-black focus:ring-0'
              : 'text-gray-500 opacity-30 no-underline outline-none'
          }`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

DarkTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  justify: PropTypes.oneOf(['start', 'center', 'end', 'between', 'around', 'evenly']),
}

export default DarkTabs
